import {
  apply, put, select,
} from 'redux-saga/effects';
import moment from 'moment';

import { loadNotes as loadNotesAction, loadNotesSucceeded } from '../reducers/note.reducers';
import {
  addMessage,
  removeMessagesByType,
} from '../reducers/message.reducers';

export function* createNote(noteApi, { payload }) {
  const response = yield apply(noteApi, noteApi.createNote, [payload]);

  if (response.errorCode) {
    yield put(addMessage({ message: 'Notiz konnte nicht erstellt werden', type: 'createNoteFailed', level: 'error' }));
    return;
  }

  const dateRange = yield select(state => state.filter.dateRange);
  const startDate = moment.unix(dateRange.startDate).toISOString();
  const endDate = moment.unix(dateRange.endDate).toISOString();

  yield put(loadNotesAction({
    entityName: response.entityName, entityId: response.entityId, startDate, endDate,
  }));
}

export function* loadNotes(noteApi, { payload }) {
  yield put(removeMessagesByType('loadNotesFailed'));
  const response = yield apply(noteApi, noteApi.loadNotes, [payload]);

  if (response.errorCode) {
    yield put(addMessage({ message: 'Notizen konnten nicht geladen werden', type: 'loadNotesFailed', level: 'error' }));
    return;
  }

  yield put(loadNotesSucceeded(response));
}

export function* deleteNote(noteApi, { payload }) {
  const response = yield apply(noteApi, noteApi.deleteNote, [payload]);

  if (response.errorCode) {
    yield put(addMessage({ message: 'Notizen konnten nicht gelöscht werden', type: 'deleteNoteFailed', level: 'error' }));
    return;
  }

  const dateRange = yield select(state => state.filter.dateRange);
  const startDate = moment.unix(dateRange.startDate).toISOString();
  const endDate = moment.unix(dateRange.endDate).toISOString();

  yield put(loadNotesAction({
    entityName: payload.entityName, entityId: payload.entityId, startDate, endDate,
  }));
}
